import { overlay } from "./Overlay.module.css";

function Overlay() {
  return <div className={overlay}></div>;
}

export default Overlay;
